<template>
  <div class="blue-bg mt-0 mt-md-2">
    <div class="container text-center">
      <img src="https://snippcheck.blob.core.windows.net/files/PG_2008946_MarketBasketEvergreen/stepsimg.png" class="img-fluid col-md-8 m-auto" alt="Three-step instructions: 1. Buy $30 of qualifying P&G products. 2. Snap a photo of your receipt. 3. Upload at PGMarketBasket.com.">
  </div>
  </div>
  <div class="container text-center pb-5 mt-1">
    <div class="mb-5">
      <section class="wrapper">
        <component :is="WidgetComponent"  :campaign-id="$t('CampaignID')"></component>
      </section>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-9">
   <div class="text-center needhelp-blk" v-html="$t('Upload.UploadBtmTxt')">
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignWidgets from '../Home/Homepagecomponents/CampaignWidgets.vue';

export default {
  components: { CampaignWidgets },
  props: {

  },
  data() {
    return {
      showComponent: false,
      WidgetComponent: CampaignWidgets,
    };
  },
};
</script>
